export default __webpack_public_path__ + "static/imgAboutUspng-f917a456b30301d12ab030737b15041b.png";